<template>
	<div class="ace-editor" ref="ace" @keydown='keyboard'></div>
</template>
<script>
	import ace from 'ace-builds'
	import 'ace-builds/src-noconflict/snippets/javascript'
	import 'ace-builds/src-noconflict/snippets/html'
	import 'ace-builds/src-noconflict/snippets/css'
	import 'ace-builds/src-noconflict/snippets/scss'
	import 'ace-builds/src-noconflict/snippets/json'
	import 'ace-builds/src-noconflict/snippets/java'
	import 'ace-builds/src-noconflict/snippets/text'
	import 'ace-builds/webpack-resolver'
	import 'ace-builds/src-noconflict/ext-language_tools'
	import 'ace-builds/src-noconflict/theme-monokai'
	import 'ace-builds/src-noconflict/mode-html'

	const modeArray = [{
		name: 'JavaScript',
		path: 'ace/mode/javascript'
	}, {
		name: 'HTML',
		path: 'ace/mode/html'
	}, {
		name: 'CSS',
		path: 'ace/mode/css'
	}, {
		name: 'SCSS',
		path: 'ace/mode/scss'
	}, {
		name: 'Json',
		path: 'ace/mode/json'
	}, {
		name: 'Java',
		path: 'ace/mode/java'
	}, {
		name: 'Text',
		path: 'ace/mode/text'
	}];

	export default {
		name:'codeEditor',
		props:['value'],
		mounted(){
			let me = this;
			setTimeout(() => {
				me.aceEditor = ace.edit(me.$refs.ace, {
				    fontSize: 14,
				    value: me.value ? me.value : '',
				    theme: me.themePath,
				    mode: me.modePath,
				    wrap: me.wrap,
				    tabSize: 4
				});
				// 激活自动提示
				me.aceEditor.setOptions({
				    enableSnippets: true,
				    enableLiveAutocompletion: true,
				    enableBasicAutocompletion: true
				});
				me.aceEditor.setShowPrintMargin(false);
				me.aceEditor.getSession().on('change', me.change);
			},1000);
				
		},
		data () {
		  return {
		    aceEditor: null,
		    wrap: true,
		    themePath: 'ace/theme/monokai',
		    modePath: 'ace/mode/html',
		    modeArray: modeArray
		  }
		},
		methods: {
		  change () {
		    this.$emit('input', this.aceEditor.getSession().getValue())
		  },
		  modelPathChange (modelPath) {
		    this.aceEditor.getSession().setMode(modelPath)
		  },
		  wrapChange (wrap) {
		    this.aceEditor.getSession().setUseWrapMode(wrap)
		  },
		  getValue(){
		  	return this.aceEditor.getSession().getValue();
		  },
		  setValue(val){
		  	this.aceEditor.getSession().setValue(val);
		  },
		  keyboard(e){
		  	this.$emit('keyboard',e);
		  	return false;
		  }
		}
  	}
</script>

<style>
	.ace-editor{
		height: 100%;
	}
</style>





// WEBPACK FOOTER //
// src/components/code-editor.vue